<template>
  <div class="add-user">
    <vjs-modal :name="modalName" title="Add User" icon="la la-plus-circle">
      <template slot="body-content">
        <form id="register-user" role="form"
              method="post"
              @submit.prevent="saveNewUser">
          <div class="form-body">
            <div role="alert" class="alert alert-secondary">
              <div class="alert-icon">
                <i class="flaticon-questions-circular-button" />
              </div>
              <div class="alert-text">
                Upon creation the user will be sent an email to verify their account and set a password.
              </div>
            </div>

            <div class="form-group">
              <div class="input-group kt-input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text">
                    <i class="fa fa-user" />
                  </span>
                </div>
                <input v-model="name" v-validate="'required|alpha_spaces'"
                       type="text"
                       name="name" :class="{'form-control': true, 'kt-input': true, 'has-error': errors.has('name') }"
                       placeholder="Full Name">
              </div>
              <transition name="fade">
                <p v-show="errors.has('name')" class="help is-danger">
                  {{ errors.first('name') }}
                </p>
              </transition>
            </div>

            <div class="form-group">
              <div class="input-group kt-input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text">
                    <i class="fa fa-envelope" />
                  </span>
                </div>
                <input v-model="email" v-validate="'required|email'"
                       type="text"
                       name="email" :class="{'form-control': true, 'kt-input': true, 'has-error': errors.has('email') }"
                       placeholder="Enter Email">
              </div>
              <transition name="fade">
                <p v-show="errors.has('email')" class="help is-danger">
                  {{ errors.first('email') }}
                </p>
              </transition>
            </div>

            <div class="form-group">
              <div class="input-group kt-input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text">
                    <i class="fa fa-building" />
                  </span>
                </div>
                <input type="text" class="form-control kt-input"
                       :placeholder="customer.name"
                       disabled="">
              </div>
            </div>

            <div class="row">
              <div class="col-12">
                <div class="form-group">
                  <label>User Type</label>
                  <div class="kt-radio-inline">
                    <label class="kt-radio">
                      <input id="standard" v-model="user_type"
                             type="radio"
                             value="standard"> Standard
                      <span />
                    </label>
                    <label v-if="permissionsIsAdmin" class="kt-radio">
                      <input id="admin" v-model="user_type"
                             type="radio"
                             value="admin"> Admin
                      <span />
                    </label>
                    <label v-if="permissionsIsOrganisationAdmin" class="kt-radio">
                      <input id="organisation_admin" v-model="user_type"
                             type="radio"
                             value="organisation_admin"> Organisation Admin
                      <span />
                    </label>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-6">
                <div class="d-flex flex-column">
                  <ss-checkbox id="status" v-model="status">
                    Enabled
                  </ss-checkbox>
                </div>
              </div>
            </div>
          </div>
        </form>
      </template>
      <template slot="body-controls">
        <button type="button" class="btn btn-ss-cancel" @click="$modal.hide(modalName)">
          Close
        </button>
        <button type="button" class="btn btn-ss-standout" @click="saveNewUser">
          Save User
        </button>
      </template>
    </vjs-modal>
  </div>
</template>

<script>
import VjsModal from 'VueModals/VjsModal';

import VeeValidate from 'vee-validate';

Vue.use(VeeValidate);

export default {
  name: 'AddUser',
  components: { VjsModal },
  props: {
    customer: {
      type: Object,
      required: true,
    },
    modalName: {
      type: String,
      required: false,
      default: `add-user-modal`,
    },
  },
  data: () => ({
    formIncomplete: false,
    name: '',
    email: '',
    password: '',
    password_confirmation: '',
    user_type: 'standard',
    status: 1,
  }),
  methods: {
    saveNewUser() {
      const form_data = {
        name: this.name,
        email: this.email,
        user_type: this.user_type,
        status: this.status,
        customer_uuid: this.customer ? this.customer.uuid : null,
      };

      if (this.customer) {
        form_data.customer_uuid = this.customer.uuid;
      }

      this.$validator.validateAll().then((result) => {
        if (result) {
          axios.post(`/api/v1/user`, form_data)
            .then((response) => {
              if (response.data && response.data.data) {
                toastr.success('User Added');
                EventBus.$emit('user-added', response.data.data);
                this.resetForm();
              }
            })
            .catch((error) => {
              window.handleAxiosError(error);
            });
        } else {
          toastr.error('Some fields have not been completed correctly');
        }
      });
    },
    resetForm() {
      this.name = '';
      this.email = '';
      this.user_type = 'standard';
      this.status = 1;
      this.errors.clear();
    },
  },
};
</script>

<style scoped lang='scss'>
.add-user {
	.add-user-button {
		margin-bottom: 20px;
	}
}

input.has-error {
	border: 1px solid #e73d4a;
}

p.is-danger,
ul.is-danger {
	margin-top: 5px;
	color: #e73d4a;
}

.mt-checkbox-list {
	.mt-checkbox:last-child {
		margin-bottom: 0;
	}
}

.form {
	.custom-alerts {
		margin: 0 20px;
		p {
			margin: 5px 0;
		}
		i {
			padding-right: 10px;
		}
	}
}
</style>
